import { render, staticRenderFns } from "./AgeRestrictionAlert.vue?vue&type=template&id=1cccf09a&scoped=true&"
import script from "./AgeRestrictionAlert.vue?vue&type=script&lang=ts&"
export * from "./AgeRestrictionAlert.vue?vue&type=script&lang=ts&"
import style0 from "./AgeRestrictionAlert.vue?vue&type=style&index=0&id=1cccf09a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cccf09a",
  null
  
)

export default component.exports